import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountState } from '@shared/states/account.state';

@Component({
  selector: 'brand-menu',
  templateUrl: './brand-menu.component.html',
  styleUrls: ['./brand-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BrandMenu {
  private store = inject(Store);

  @Input()
  @HostBinding('class')
  class: string;

  branding() {
    const branding = this.store.selectSnapshot(AccountState.parentBranding);
    // console.warn('<brand-menu>', branding);
    return branding;
  }
}
